import {IPortalseite} from "../Interfaces";
import Veraportal from "./../Veraportal";

export default class RueckmeldungKsVergleich extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        const chartDom: HTMLDivElement = document.getElementById('chart-ks-vergleich') as HTMLDivElement;
        const myChart = echarts.init(chartDom);

        const categoryColors = {
            'KS1': '#ff7f50',
            'KS2': '#87ceeb',
            'KS3': '#98fb98',
            'KS4': '#dda0dd',
            'KS5': '#f0e68c'
        };

        // Chart configuration options
        const option: any = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: (params: any) => {
                    let total = 0;
                    let result = `${params[0].seriesName}<br/>`;
                    params.forEach((param: any) => {
                        total += param.value;
                        result += `${param.name}: ${param.value}%<br/>`;
                    });
                    result += `Total: ${total}%`;
                    return result;
                }
            },
            legend: {
                data: ['KS1', 'KS2', 'KS3', 'KS4', 'KS5']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                max: 100,
                axisLabel: {
                    formatter: '{value}%'
                }
            },
            yAxis: {
                type: 'category',
                data: ['Bar 1', 'Bar 2', 'Bar 3']
            },
            series: [
                {
                    name: 'KS1',
                    type: 'bar',
                    stack: 'total',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [20, 25, 15]  // Percentage for KS1 in each bar
                },
                {
                    name: 'KS2',
                    type: 'bar',
                    stack: 'total',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [25, 20, 20]  // Percentage for KS2 in each bar
                },
                {
                    name: 'KS3',
                    type: 'bar',
                    stack: 'total',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [20, 25, 25]  // Percentage for KS3 in each bar
                },
                {
                    name: 'KS4',
                    type: 'bar',
                    stack: 'total',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [15, 15, 20]  // Percentage for KS4 in each bar
                },
                {
                    name: 'KS5',
                    type: 'bar',
                    stack: 'total',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [20, 15, 20]  // Percentage for KS5 in each bar
                }
            ]
        };

        // Set options and render the chart
        option && myChart.setOption(option);

        // Handle window resize
        window.addEventListener('resize', () => {
            myChart.resize();
        });


        return true
    }

    override async onSeiteFinished(): Promise<boolean> {
        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        return true;
    }

}